import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { CoreService } from "src/app/shared/services/core.service";
import { GlobalSettingsResolver } from "./global-settings.resolver";


@Injectable({
  providedIn: "root"
})
export class VerificationInitResolver implements Resolve<boolean> {
  constructor(
    protected globalSettingsResolver: GlobalSettingsResolver,
    protected coreService : CoreService,
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise(async (res, rej) => {
      await Promise.all([
        this.globalSettingsResolver.resolve(route, state)
      ]);

      this.coreService.isDataLoaded.next(true);

      res(true);
    });
  }
}
